import React, { useState } from 'react';
import { ArrowRight, HeartIcon } from 'lucide-react';
import { DS } from '../ds';
import { Label, P } from '../Primitives';
export const KitSection = ({
  onCTA
}: {
  onCTA?: (id: string) => void;
}) => {
  const [activeDetail, setActiveDetail] = useState(0);
  const details = [{
    title: 'Caja kraft natural',
    desc: 'Cartón reciclado premium. Logo impreso con tinta de base agua. La textura comunica cuidado artesanal en cada caso.',
    tag: 'Eco · Reciclado · Personalizable',
    image: 'https://cdn.magicpatterns.com/uploads/6kE4wDGiWSF3PswBxPcucs/WhatsApp_Image_2026-07-16_at_9.57.51_AM_(1).jpg',
    imageAlt: 'Caja kraft natural Alinova abierta'
  }, {
    title: 'Bolsa de tela lino',
    desc: 'Lino natural bordado con logo. Reutilizable, duradera y sostenible. Una experiencia táctil que ningún otro brand ofrece.',
    tag: 'Natural · Bordado · Durable',
    image: 'https://cdn.magicpatterns.com/uploads/8VgHaqwJekps6FkM8nVUxD/WhatsApp_Image_2026-07-16_at_9.58.53_AM.jpg',
    imageAlt: 'Bolsa de tela lino Alinova con logo bordado'
  }, {
    title: 'Estuche con espejo',
    desc: 'Bioplástico con cierre premium y espejo interior. Diseñado para el uso cotidiano del paciente.',
    tag: 'Bioplástico · Funcional · Sostenible',
    image: 'https://cdn.magicpatterns.com/uploads/hFPsU1uMafTeDoUjiYwVnp/WhatsApp_Image_2026-07-28_at_9.10.56_PM.jpg',
    imageAlt: 'Estuche Alinova con espejo y alineadores transparentes'
  }, {
    title: 'Acceso digital + detalle de marca',
    tag: 'Digital · Premium · Memorable',
    desc: 'Tarjeta de acceso a la plataforma Alinova con QR para seguimiento del caso, más un pequeño obsequio físico que cierra la experiencia del tratamiento.',
    image: 'https://cdn.magicpatterns.com/uploads/huaduGvfbNsEbRpNdjnne5/WhatsApp_Image_2026-07-28_at_9.08.46_PM.jpg',
    imageAlt: 'Experiencia Alinova con acceso digital y detalle de marca'
  }];
  return <section id="kit" style={{
    padding: '80px 24px 0',
    background: `linear-gradient(160deg, ${DS.color.linen} 0%, ${DS.color.ivory} 60%)`,
    position: 'relative',
    overflow: 'hidden'
  }} data-id="element-640" data-mp="3qsk1pejw7wlc">
      {/* Textura de fondo */}
      <div style={{
      position: 'absolute',
      inset: 0,
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg width='80' height='80' viewBox='0 0 80 80' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23B5894F' fill-opacity='0.025'%3E%3Cpath d='M0 0h80v80H0z'/%3E%3Ccircle cx='40' cy='40' r='2'/%3E%3C/g%3E%3C/svg%3E\")",
      pointerEvents: 'none'
    }} data-id="element-641" data-mp="4jiwbfsv83qa" />

      <div style={{
      maxWidth: '1200px',
      margin: '0 auto',
      position: 'relative',
      zIndex: 1
    }} data-id="element-642" data-mp="idjxshb7c4uc">
        {/* Header */}
        <div style={{
        textAlign: 'center',
        maxWidth: '680px',
        margin: '0 auto 64px'
      }} data-id="element-643" data-mp="x86ntt47jpca">
          <div style={{
          display: 'flex',
          justifyContent: 'center'
        }} data-id="element-644" data-mp="1bykpodlsn4m3">
            <Label data-id="element-645" data-mp="1fzd0hbabdhkh">Kit eco-premium</Label>
          </div>
          <h2 style={{
          fontFamily: DS.font.heading,
          fontWeight: 700,
          fontSize: 'clamp(2rem, 4.5vw, 3.2rem)',
          background: `linear-gradient(135deg, ${DS.color.aqua}, ${DS.color.teal})`,
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
          lineHeight: 1.12,
          letterSpacing: '-0.025em',
          marginBottom: '20px'
        }} data-id="element-646" data-mp="1fwqsxbnfb229">
            Una experiencia que también se siente en la entrega.
          </h2>
          <div style={{
          display: 'flex',
          justifyContent: 'center'
        }} data-id="element-647" data-mp="o5kqupo56uac">
            <P align="center" maxWidth="560px" data-id="element-648" data-mp="9bpkprfdfj2u">
              El único sistema de alineadores en Colombia con una presentación
              eco-premium que eleva la percepción de tu clínica en cada caso.
            </P>
          </div>
        </div>

        {/* Grid imagen + detalles */}
        <div className="col-2" style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1.1fr',
        gap: '48px',
        alignItems: 'center'
      }} data-id="element-649" data-mp="1cmd7y8jp9nvj">
          {/* Imagen */}
          <div style={{
          position: 'relative'
        }} data-id="element-650" data-mp="12to9ce9904hm">
            <div style={{
            borderRadius: DS.radius.cardLg,
            overflow: 'hidden',
            boxShadow: '0 32px 100px rgba(11,31,36,0.18)',
            background: DS.color.linen,
            aspectRatio: '4/5',
            position: 'relative'
          }} data-id="element-651" data-mp="xxh0odpgwevz">
              <img src={details[activeDetail].image} alt={details[activeDetail].imageAlt} style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              objectPosition: 'center',
              display: 'block',
              transition: `transform 0.5s ${DS.ease.smooth}`
            }} onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.03)'} onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'} data-id="element-652" data-mp="jyr4d0ah2j8o" />
            </div>

            {/* Badge flotante */}
            <div style={{
            position: 'absolute',
            bottom: '24px',
            left: '-16px',
            background: DS.color.tealDeep,
            borderRadius: '16px',
            padding: '14px 18px',
            boxShadow: '0 12px 40px rgba(13,59,80,0.28)',
            display: 'flex',
            alignItems: 'center',
            gap: '12px'
          }} data-id="element-653" data-mp="27u5ouf3flvbm">
              <HeartIcon size={24} color={DS.color.aquaLight} strokeWidth={1.6} data-id="element-654" data-mp="3t67728rvpg9a" />
              <div data-id="element-655" data-mp="1t47kc0ylt6sc">
                <div style={{
                fontFamily: DS.font.heading,
                fontWeight: 700,
                fontSize: '13px',
                color: '#fff'
              }} data-id="element-656" data-mp="1t3o3knkowofw">
                  Experiencia real
                </div>
                <div style={{
                fontFamily: DS.font.body,
                fontSize: '11px',
                color: 'rgba(255,255,255,0.55)'
              }} data-id="element-657" data-mp="1y5diieb19m99">
                  Kit Alinova
                </div>
              </div>
            </div>
          </div>

          {/* Detalles accordion */}
          <div data-id="element-658" data-mp="1efjrw3k21d6m">
            <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '10px'
          }} data-id="element-659" data-mp="1ef1p0o2w00pq">
              {details.map((d, i) => {
              const isActive = activeDetail === i;
              return <button key={i} onClick={() => setActiveDetail(i)} aria-expanded={isActive} style={{
                textAlign: 'left',
                cursor: 'pointer',
                borderRadius: '18px',
                padding: isActive ? '22px 24px' : '16px 24px',
                background: isActive ? '#fff' : 'rgba(255,255,255,0.55)',
                border: `1.5px solid ${isActive ? DS.color.kraft : DS.color.border}`,
                boxShadow: isActive ? '0 12px 40px rgba(11,31,36,0.09)' : 'none',
                transition: `all 0.28s ${DS.ease.smooth}`
              }} onMouseEnter={e => {
                if (!isActive) {
                  e.currentTarget.style.background = 'rgba(255,255,255,0.85)';
                  e.currentTarget.style.borderColor = DS.color.linen;
                }
              }} onMouseLeave={e => {
                if (!isActive) {
                  e.currentTarget.style.background = 'rgba(255,255,255,0.55)';
                  e.currentTarget.style.borderColor = DS.color.border;
                }
              }} data-id="element-660" data-mp="ckqb99nhhlln" data-mpi={i}>
                    <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '16px'
                }} data-id="element-661" data-mp="3b3cdnrslbrm1">
                      <div style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '12px',
                    flexShrink: 0,
                    background: isActive ? `linear-gradient(135deg, ${DS.color.kraft}, #9a6f3a)` : DS.color.linen,
                    color: isActive ? '#fff' : DS.color.kraft,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontFamily: DS.font.heading,
                    fontWeight: 700,
                    fontSize: '15px',
                    transition: 'all 0.28s'
                  }} data-id="element-662" data-mp="31bq5y5fgoao1">
                        {String(i + 1).padStart(2, '0')}
                      </div>
                      <div style={{
                    flex: 1
                  }} data-id="element-663" data-mp="24954h2ik2te0">
                        <div style={{
                      fontFamily: DS.font.heading,
                      fontWeight: 700,
                      fontSize: '16px',
                      color: DS.color.tealDeep
                    }} data-id="element-664" data-mp="249ewswr2pcmv">
                          {d.title}
                        </div>
                        {isActive && <div style={{
                      fontFamily: DS.font.body,
                      fontSize: '11px',
                      fontWeight: 600,
                      color: DS.color.kraft,
                      marginTop: '2px',
                      letterSpacing: '0.02em'
                    }} data-id="element-665" data-mp="1syhqyj6e0sc9">
                            {d.tag}
                          </div>}
                      </div>
                    </div>

                    {isActive && <div style={{
                  marginTop: '14px',
                  paddingLeft: '56px'
                }} data-id="element-666" data-mp="2pqlfhtxpogbh">
                        <P size="base" data-id="element-667" data-mp="vcamradzx20f">{d.desc}</P>
                      </div>}
                  </button>;
            })}
            </div>
          </div>
        </div>

        {/* CTA — Verifica nuestros precios */}
        <div style={{
        marginTop: '48px',
        padding: '20px 28px',
        borderRadius: '16px',
        background: DS.color.white,
        border: `1px solid ${DS.color.border}`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '16px',
        flexWrap: 'wrap'
      }} data-id="element-668" data-mp="j0rtoiuywzhj">
          <div data-id="element-669" data-mp="11tlum8vrar2r">
            <div style={{
            fontFamily: DS.font.heading,
            fontWeight: 700,
            fontSize: '15px',
            color: DS.color.ink,
            marginBottom: '3px'
          }} data-id="element-670" data-mp="11qzrqmjt8zqv">
              ¿Quieres saber cuánto incluye el kit en cada plan?
            </div>
            <div style={{
            fontFamily: DS.font.body,
            fontSize: '13px',
            color: DS.color.muted
          }} data-id="element-671" data-mp="3di3n9277x2hq">
              Cada modalidad incluye el kit eco-premium completo desde el primer caso.
            </div>
          </div>

          <a href="#planes" onClick={e => {
          e.preventDefault();
          onCTA?.('planes');
        }} style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '8px',
          padding: '11px 24px',
          borderRadius: DS.radius.pill,
          background: DS.color.kraft,
          color: '#fff',
          fontFamily: DS.font.body,
          fontSize: '14px',
          fontWeight: 700,
          textDecoration: 'none',
          transition: `all 0.22s ${DS.ease.smooth}`,
          whiteSpace: 'nowrap'
        }} onMouseEnter={e => {
          e.currentTarget.style.background = '#9a6f3a';
        }} onMouseLeave={e => {
          e.currentTarget.style.background = DS.color.kraft;
        }} data-id="element-672" data-mp="35xssaak2kywp">
            Verifica nuestros precios
            <ArrowRight size={15} aria-hidden="true" data-id="element-673" data-mp="1tqhhym8088ar" />
          </a>
        </div>
      </div>

      {/* Espaciado inferior */}
      <div style={{
      height: '40px'
    }} data-id="element-674" data-mp="23msy5naptiah" />
    </section>;
};